import React from "react";

export function InfoEmail() {
  return (
    <a href="mailto:hello@manchesterstudentsgroup.com">
      hello@manchesterstudentsgroup.com
    </a>
  );
}
